import Container from "../layout/Container"

function Eventos (){
    return (
        <div>
            <Container>
                <h1>Eventos na cidade</h1>

                <p>Neste espaço iremos divulgar os eventos da cidade.</p>
            </Container>
        </div>
    )
}
export default Eventos